<template>
  <div class="search-container" :style="'background-image: url(' + SearchBg+')'" v-loading="loading">
    <div class="banner">
      <p class="banner-title">一键查询全国薪酬、社保、公积金政策</p>
      <p class="banner-sub-title">
        <span style="margin-right: 10px">500+ 城市</span>
        <span>2000+ 政策详情</span>
      </p>
    </div>
    <el-card class="search-box-page" :class="{ 'search-box-page-en': lang == 'en' }">
      <div class="search-item">
        <label class="search-item-label" style="padding-right: 11px">{{ $t('scopeOfApplication') }}</label>
        <div class="search-content">
          <el-select class="select-round" size="medium" v-model="queryParams.scope" :placeholder="$t('pleaseQuery')" filterable clearable @change="scopeChange">
            <i class="el-icon-search color-primary font-16 ml5" slot="prefix"></i>
            <el-option-group v-for="group in setIdByItemList" :key="group.label" :label="group.label">
              <el-option v-for="item in group.options" :key="item.codeItemId" :value="item.codeItemId + ''" :label="item.codeItemName" />
            </el-option-group>
          </el-select>
        </div>
      </div>
      <div class="search-item hot-search" v-if="!queryParams.scope">
        <label class="search-item-label">{{ $t('searchHistory') }}：</label>
        <div class="search-content">
          <span class="hot-link pointer" v-for="(item, index) in searchHistory" :key="index" @click="handleHotSearch(item)">{{ item | dictListFilter(getScopeList) }}</span>
        </div>
      </div>
    </el-card>
    <div class="search-result">
      <custom-tabs :tabs="tabs" @tab-click="tabClick" :default-active="tabActive" v-if="queryParams.scope && hasPermission">
        <template slot="tabContent">
          <pay-policy ref="payPolicy" v-if="tabActive == 0" :datas="payPolicyData"></pay-policy>
          <social-security-provident-fund-policy ref="socialSecurityProvidentFundPolicy" v-if="tabActive == 1"  :datas="socialSecurityProvidentFundPolicyData"></social-security-provident-fund-policy>
        </template>
      </custom-tabs>
      <lock v-else-if="queryParams.scope && !hasPermission"></lock>
      <empty v-else></empty>
    </div>
  </div>
</template>

<script>
  import CustomTabs from '@/components/v2/custom-tabs/index';
  import PayPolicy from '@/views/policy/policyLibrary/policyDictionary/components/PayPolicy';
  import SocialSecurityProvidentFundPolicy from '@/views/policy/policyLibrary/policyDictionary/components/SocialSecurityProvidentFundPolicy';
  import Lock from '@/views/policy/policyLibrary/policyDictionary/components/Lock';
  import Empty from '@/views/policy/policyLibrary/policyDictionary/components/Empty';
  import SearchBg from '@/assets/img/policy/search-bg.png';
  import * as api from '@/api/policy/policyLibrary';
  import { validatenull } from "@/util/validate";
  import { mapGetters } from 'vuex';
  export default {
    name: "PolicyDictionary",
    components: {
      CustomTabs,
      PayPolicy,
      SocialSecurityProvidentFundPolicy,
      Lock,
      Empty
    },
    created() {
      this.getSetIdByItemList();
      this.getHotSearchList();
    },
    data() {
      return {
        SearchBg,
        queryParams:{
          scope: ''
        },
        setIdByItemList: [],
        searchHistory: [],
        tabs: [
          { label: this.$t('payPolicy') },
          { label: this.$t('socialSecurityProvidentFundPolicy') }
        ],
        tabActive: 0,
        payPolicyData: {},
        socialSecurityProvidentFundPolicyData: {},
        hasPermission: false,
        loading: false
      }
    },
    methods: {
      // 获取适用范围
      getSetIdByItemList() {
        let params = {
          setList: 1036,
          isGroup: 1
        }
        api.setIdByItemList(params)
          .then(res => {
            this.setIdByItemList = res.data.data;
          })
          .catch(error =>{
            this.setIdByItemList = [];
          })
      },
      // 获取搜索历史
      getHotSearchList() {
        api.libraryHistory()
          .then(res => {
            this.searchHistory = res.data.data
          })
      },
      // 薪酬政策和社保公积金政策选项卡切换
      tabClick({ index, tab }) {
        this.tabActive = index;
        this.getData();
      },
      // 热门搜索点击，代入适用范围
      handleHotSearch(val) {
        this.queryParams.scope = val;
        this.tabActive = 0;
        this.getData();
      },
      // 适用范围change
      scopeChange(val) {
        this.tabActive = 0;
        if (val) {
          this.getData();
        } else {
          this.getHotSearchList();
        }
      },
      // 获取数据
      getData() {
        if (this.tabActive == 0) {
          this.getPayPolicyData();
        } else {
          this.getSocialSecurityProvidentFundPolicyData();
        }
      },
      // 获取薪酬政策数据
      getPayPolicyData() {
        this.loading = true;
        let params = {
          ...this.queryParams
        }
        api.wagePolicyList(params)
          .then(res => {
            this.loading = false;
            if (res.data.code == 0) {
              this.payPolicyData = res.data.data;
            } else {
              this.payPolicyData = {};
            }
            this.hasPermission = res.data.code != 1;
          })
          .catch(error =>{
            this.payPolicyData = {};
            this.loading = false;
          })
      },
      // 获取社保公积金政策数据
      getSocialSecurityProvidentFundPolicyData() {
        this.loading = true;
        let params = {
          ...this.queryParams
        }
        api.reserveFundList(params)
          .then(res => {
            this.loading = false;
            if (res.data.code == 0) {
              this.socialSecurityProvidentFundPolicyData = res.data.data;
            } else {
              this.socialSecurityProvidentFundPolicyData = {};
            }
            this.hasPermission = res.data.code != 1;
          })
          .catch(error =>{
            this.socialSecurityProvidentFundPolicyData = {};
            this.loading = false;
          })
        
      }
    },
    computed: {
      ...mapGetters(['dicts', 'lang']),
      getScopeList() {
        let scopeList = [];
        this.setIdByItemList.forEach(group => {
          scopeList = [...scopeList, ...group.options];
        })
        console.log(scopeList)
        return scopeList;
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
